import type { WidgetEmptyReason } from '@content-scheduler/shared/render';
import styles from './Placeholder.module.css';

export type PlaceholderKind = WidgetEmptyReason | 'error' | 'unconfigured';

const COPY: Record<PlaceholderKind, [title: string, text: string]> = {
    empty: [
        'Nothing to show right now',
        'Open Settings to create an announcement. An evergreen announcement shows whenever nothing is scheduled.',
    ],
    legacy: [
        'This widget has been upgraded',
        'Designs made with the old editor no longer display. Open Settings to recreate your announcement with a new template.',
    ],
    widget_limit: [
        'Your plan includes one widget',
        'Upgrade your plan to show announcements in more than one place.',
    ],
    plan_expired: ['Your free trial has ended', 'Choose a plan to show your announcements again.'],
    error: ["Couldn't load your announcement", 'Check your connection, then reload the editor.'],
    unconfigured: [
        'Widget is missing its Wix parameters',
        'Open this page through the Wix editor, or add ?instance=…&compId=… for local development.',
    ],
};

export function Placeholder({ kind }: { kind: PlaceholderKind }) {
    const [title, text] = COPY[kind];
    return (
        <div className={styles.placeholder} data-placeholder={kind}>
            <p className={styles.title}>{title}</p>
            <p className={styles.text}>{text}</p>
        </div>
    );
}
